module.exports = __webpack_public_path__ + "static/img/AIphoto.b848a844.png";